import queries from '@apis/queries';
import useProjectId from '@hooks/useProjectId';
import { PaymentMethod } from '@models/order';
import { useQuery } from '@tanstack/react-query';

const cafegateId = '0q2r1cxqqwjd1';

function usePaymentMethods(): PaymentMethod[] {
    const { data } = useQuery(queries.paymentMethod.list());
    const projectId = useProjectId();
    const result: PaymentMethod[] = [...(data?.paymentMethods || [])];
    // TODO 하드코딩 제거
    if (projectId === cafegateId) {
        result.push('TOSS_PAY');
    }
    return result;
}

export default usePaymentMethods;
